/* eslint-disable import/default */
import Vue from 'vue'

import VueScrollTo from 'vue-scrollto'
/* eslint-disable no-unused-vars */
import { TweenMax } from 'gsap'
import lodash from 'lodash'

Vue.use(VueScrollTo, {
  container: `#main`,
  duration: 550,
  easing: `ease-in-out`,
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(lodash)
